<div id="finanzamtAngaben">

    <div class="mb-5x pt-1">
        <div class="d-flex justify-content-start">
            <h2 class="mr-auto">{{ 'COMMON_UI.FRAGEBOGEN.FINANZAMT.TITEL' | translate }}</h2>
            <common-ui-entwurf-loeschen [readonly]="readonly" context="">
            </common-ui-entwurf-loeschen>
            <common-ui-conversion-hint context=""></common-ui-conversion-hint>
            <common-ui-daten-uebernahme
                    (picked)="data.finanzamt = $event"
                    [itemTemplate]="datenuebernahmeSteuernummer"
                    [items]="[stammdaten?.antragsteller?.finanzamt, stammdaten?.unternehmen?.finanzamt]"
                    [readonly]="readonly"
                    context="Finanzamt">
            </common-ui-daten-uebernahme>
        </div>
        <div class="col-sm-12 col-lg-12 p-0 mb-3x mt-1x">
            <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.FINANZAMT.HINWEIS' | translate"
                            type="info"></common-ui-card>
        </div>
        <common-ui-finanzamt [(data)]="data.finanzamt" [readonly]="readonly"></common-ui-finanzamt>
    </div>
</div>

<ng-template #datenuebernahmeSteuernummer let-item="item">
    <h4 class="list-group-item-heading">
        {{ 'COMMON_UI.FRAGEBOGEN.FINANZAMT.STAMMDATEN_UEBERNAHME_FINANZAMT' | translate }} {{item?.finanzamtnummer}}
        <br>
        {{ 'COMMON_UI.FRAGEBOGEN.FINANZAMT.STAMMDATEN_UEBERNAHME_STEUERNUMMER' | translate }}
        {{ getSteuernummerMask(item?.finanzamtnummer).prefix }}{{ item?.steuernummer | mask: getSteuernummerMask(item?.finanzamtnummer).mask }}
    </h4>
</ng-template>
